import React, { useState, useEffect } from 'react';
import { apiRequest } from '../../api';

const RejectModal = ({ isOpen, onClose, lead }) => {
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (lead && lead.comment_reject) {
      setComment(lead.comment_reject);
    }
  }, [lead]);
  console.log("lead: ", lead);
  const handleReject = async (isReject) => {
    if (!lead) return;

    try {
      setLoading(true);
      let data_request = null
      if (isReject){
          data_request = {
            reject_status: 'approve',
        }
      } else {
        data_request = {
            reject_status: 'reject',
        }
      }
      
      await apiRequest(`leads/${lead.id}/update`, 'PATCH', data_request);
      
      onClose();
    } catch (error) {
      console.error('Ошибка при обновлении статуса брака:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !lead) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className="modal small bottom-right open" 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>Заявление на брак</h3>
        </div>
        <div className="modal-body">
          <h5>Комментарий:</h5><br/>
          <h6>{comment || 'Нет комментария'}</h6>
        </div>
        <div className="modal-footer" style={{display: 'flex', gap: '10px', justifyContent: 'flex-end'}}>
          <button 
            type="button" 
            className="btn btn-primary-filled"
            onClick={() => handleReject(true)}
            disabled={loading}
          >
            Является браком
          </button>
          <button 
            type="button" 
            className="btn btn-primary"
            onClick={() => handleReject(false)}
            disabled={loading}
          >
            Не является браком
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectModal;
